var React = require('react');

function Notifications (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"notifications-icon","d":"M.593 11.91C1.296 5.998 6.09 1.24 12.008.584c7.77-.864 14.476 5.176 14.476 12.91 0 6.998-5.535 12.703-12.468 12.98l-4.314 3.54c-1.402 1.147-3.507.15-3.507-1.66v-4.125C2.23 21.533.007 16.86.593 11.91zm2.98.355c-.48 4.05 1.468 7.842 4.88 9.843l.742.435v4.005l3.734-3.066h.56c5.52 0 9.994-4.472 9.994-9.99 0-5.95-5.156-10.594-11.144-9.927-4.534.503-8.23 4.17-8.767 8.7z","fillRule":"nonzero"}));
}

Notifications.defaultProps = {"width":"27","height":"31","viewBox":"0 0 27 31"};

module.exports = Notifications;

Notifications.default = Notifications;



//////////////////
// WEBPACK FOOTER
// ./~/svg-react-loader/lib/loader.js!./src/components/NotificationsMenu/notifications.svg
// module id = 564
// module chunks = 0